/* Ported from _deploy_baseline/_v3/motion.js by _th-v3-tools/port_assets.py. Edit the source there, then re-run the port. */
/* THUNDER HONEY V3 MOTION  (motion.js, paired with motion.css)
   One requestAnimationFrame loop, transforms and opacity only, passive listeners,
   IntersectionObserver puts off-screen elements to sleep. No libraries.
   Everything switches off under prefers-reduced-motion (flip and drag still work, instantly).

   ==========================  MARKUP CONTRACT  ==========================
   Use these by markup alone. You never need to write JS for them.

   1. PARALLAX   data-px="0.12"
      <div class="ph ph--45"><img data-px="0.12" src="img/..." alt="..."></div>
      On an img, video, picture or canvas the PARENT is the frame: motion.js gives it
      overflow:hidden. The media drifts by speed x (distance of the frame from the viewport
      centre) and is scaled up exactly enough that an empty edge can never show.
      Photos: 0.06 to 0.18. A negative value drifts the other way.
      On any other element (a glass card, a caption, a pouch cut-out) the element itself
      floats as a layer with no scaling: data-px="-0.06" makes a card rise faster than the
      page, which puts it visibly in front of the photo behind it.
      Hover zoom on parallax media: set --px-zoom, e.g. .card:hover img{--px-zoom:1.05}
      (it animates). motion.js owns the transform of a data-px element: do not also put
      data-rise, .settle or a CSS transform on it. Wrap it instead.

   2. TILT   data-tilt   (optional value = max degrees, default 6)
      <article class="card" data-tilt>...</article>
      Leans toward the pointer in 3D with a slight lift, eases back on leave.
      Desktop mouse only, off on touch. data-tilt-glare adds a soft light that follows the
      pointer (it uses ::after on that element). --tilt-x and --tilt-y (-1 to 1) and
      --tilt-g (0 to 1) are set on the element for your own light effects.
      While hovered, tilt owns the element's transform: put a hover lift on a child.

   3. BLOOM   data-bloom   (optional data-bloom-delay="200" in ms)
      <div class="grid grid-3"><article data-bloom>..</article><article data-bloom>..</article></div>
      Enters from scale(.94) translateY(24px) rotateX(7deg) and eases to rest when it
      scrolls into view. Siblings that arrive together stagger 90 ms apart on their own.
      Works together with data-tilt on the same element. Do not nest inside data-stagger.
      Bloom owns opacity and transform only until it has landed (class bloom-done), then the
      element's own CSS is back in charge. If motion.js never runs, content shows after 3.5 s.

   4. FLIP   data-flip
      <button class="flip" data-flip aria-pressed="false">
        <span class="flip__in"><span class="flip__f">FRONT</span><span class="flip__b">BACK</span></span>
      </button>
      Click, tap, Enter or Space turns it 180 degrees in 3D, toggles aria-pressed and the
      class is-flipped. Front and back share one grid cell, so the card is as tall as its
      taller face. You style the faces (.flip__f, .flip__b). A non-button element works too
      (role, tabindex and keys are added). Each card gives a small peek turn the first time
      it enters view, as a hint that it turns: data-flip="still" switches that off.
      The hidden face also gets visibility:hidden at the edge-on moment, so browsers without
      backface culling never show a mirrored back, and screen readers read the visible face.

   5. TURNTABLE   data-turntable
      <div class="tt" data-turntable data-frames="36" data-src="img/turntable/f{i}.webp" data-pad="3">
        <canvas aria-label="The Thunder Honey Daylight pouch, turning"></canvas>
      </div>
      Scroll turns it: one full turn per pass through the viewport, and the FRONT faces you
      when the .tt is centred on screen (data-turns="2" for more turns). Drag with mouse or
      finger spins it by hand with inertia. It idles slowly when nothing moves (data-idle="18"
      seconds per turn, "0" for off). Focused: arrow keys turn it, Enter enlarges it. Click or
      tap enlarges it into a full-screen view where it can be dragged; Escape closes it.
      SIZE THE .tt, NOT THE CANVAS. The .tt is 4:5 and full width by default; give it any width
      or height and the canvas fills it, sharp at devicePixelRatio. Vertical page scroll on
      phones is never blocked (touch-action: pan-y); only a sideways drag turns the pouch.
      Controls: a round Pause and an Enlarge button are added top right. data-controls="none"
      removes them, or put your own <button data-tt-pause> / <button data-tt-enlarge> inside.
      Sticky scrub: put data-tt-host on a tall ancestor (for example height:300vh with a
      position:sticky child) and one turn follows the progress through that ancestor.
      Readout: any element with data-tt-deg inside the host (or the .tt) shows the angle.
      --tt-p (0 to 1 of a turn) is set on the .tt.
      SURFACE: use the cut frames (img/turntable-cut/f{i}.webp, a clean alpha edge, re-matted
      29 Sep 2026 so both side seals are whole at every angle). They sit on any ground as they
      are, with a soft floor shadow under them, and on a light ground motion.css adds a hairline
      navy contact edge so the silver never melts into a pale halo.
      The older navy studio set (img/turntable/f{i}.webp) is swapped for the cut set on a dark
      surface. With data-blend="lighten" it is kept and blends with "lighten" instead, so the
      glow shows right up to the pouch; that blend needs the navy behind it in the same layer,
      so do NOT put such a .tt inside anything that isolates it: a transform, filter, opacity
      below 1, backdrop-filter (.glass), will-change, or an ancestor with data-px, data-tilt or
      data-bloom. The navy set on a light surface gets feathered edges (data-feather="off" to stop).

   6. MARQUEE   data-marquee   data-speed="40"   data-dir="rev"
      <div data-marquee data-speed="40"><figure>..</figure><figure>..</figure></div>
      The children are wrapped and repeated for a seamless loop with no gap. data-speed is
      seconds per loop of your original set (default 40). data-dir="rev" runs left to right.
      Give the children a width (for example width:min(78vw,340px)). The space between
      items is the element's own CSS gap (re-read on resize), or --mq-gap, or 24px.
      Eases to a stop on mouse hover and keyboard focus, sleeps off-screen. Reduced motion:
      no animation and the row scrolls by hand. Edges fade out; class mq--hard turns that off.

   7. COUNT   data-count="70000"
      <span data-count="70000">70,000</span>+ cups
      Counts up from 0 when it comes into view. English gets a comma (70,000), Swedish
      (lang="sv" on any ancestor) a narrow no-break space (70 000). Options:
      data-decimals="1", data-duration="1800" (ms), data-sep="," to force a separator.
      Write the final number as the text so it reads right without JS.

   8. GRAIN   class="grain"
      <section class="sec sec--navy grain">...</section>
      A subtle living film grain over the element (a ::after overlay above the background,
      pointer-events none, z-index 1: give content that must sit above it z-index 2).
      Adds position:relative if the element has no position, and isolation:isolate.
      grain--still stops the flicker, grain--strong doubles it.

   9. SCRUB   data-scrub   (pinned scroll sequences, added 29 Sep 2026 for the product page benefits)
      <div id="my-pin" class="pin" data-scrub>                     (tall: e.g. height:calc(100vh + 260vh))
        <div class="stage">                                          (position:sticky; top:0; height:100vh)
          <article data-scrub-step>..</article> <article data-scrub-step>..</article> ...
        </div>
      </div>
      <ol data-scrub-for="my-pin"><li><button type="button" data-scrub-go="0">..</button></li>..</ol>
      Progress through the host (0 when its top reaches the top of the viewport, 1 when its bottom
      reaches the bottom of the viewport), eased, is written as --scrub on the host and on every
      [data-scrub-for] element, plus --scrub-q (0 to 1 from the first step at rest to the last).
      The steps are spread evenly: step k is at rest at --scrub-q = k/(n-1). Each step gets
        --k    its index
        --s    its distance from rest, in steps (-1: the step before it is at rest, +1: the next one is)
        --in   0 to 1, how far it has arrived (eased); 1 at rest and after
        --out  0 to 1, how far it has left (eased); 0 at rest and before
      and class is-live while it is at all visible (--in > 0 and --out < 1). The nearest step gets
      class is-on, so does its [data-scrub-go] button (with aria-current), and the host and every
      [data-scrub-for] element get data-scrub-at="k". A [data-scrub-go="k"] button scrolls to step k;
      focus moving into a step scrolls it to rest. Options on the host: data-scrub-dwell="0.4" (the
      share of each interval a step stays at rest), data-scrub-lead="0.06" (the share of the run at
      each end where the first or last step stays at rest).
      The host gets class is-scrub once it runs. It never runs under prefers-reduced-motion, so style
      the pinned version behind html.mo:not(.mo-rm) and keep a plain layout for everything else.
      Pair it with a turntable: data-tt-host on the same host turns the pouch once over the same run.

   JS API: window.THMotion.refresh(root) sets up elements added to the page later.
   ======================================================================= */
(function () {
  'use strict';
  var d = document, w = window, html = d.documentElement;
  if (w.THMotion) return;

  function mm(q) { try { return w.matchMedia(q).matches; } catch (e) { return false; } }
  var RM = mm('(prefers-reduced-motion: reduce)');
  var FINE = mm('(hover: hover) and (pointer: fine)');
  var HAS_IO = 'IntersectionObserver' in w;
  var HAS_RO = 'ResizeObserver' in w;
  var MEDIA = /^(img|video|picture|canvas|svg)$/i;

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function num(v, def) { v = parseFloat(v); return isFinite(v) ? v : def; }
  function now() { return w.performance && performance.now ? performance.now() : Date.now(); }
  function all(root, sel) {
    var list = [].slice.call(root.querySelectorAll(sel));
    if (root.nodeType === 1 && root.matches && root.matches(sel)) list.unshift(root);
    return list;
  }
  function viewH() { return w.innerHeight || html.clientHeight || 1; }
  /* frame-rate independent easing: fraction of the remaining distance to cover in dt ms */
  function ease(dt, rate) { return 1 - Math.exp(-dt * rate); }
  function io(opts, fn) { return HAS_IO ? new IntersectionObserver(fn, opts) : null; }
  function warn(e) { if (w.console && console.warn) console.warn('[motion]', e); }

  /* ------------------------------------------------------------------
     THE ONE LOOP. Modules register {read, write}. All layout reads happen
     before all style writes in the same frame, so nothing thrashes. The loop
     sleeps when no module asks for another frame.
     ------------------------------------------------------------------ */
  var tasks = [], queued = false, lastT = 0, dirty = true;
  function kick() { if (!queued) { queued = true; w.requestAnimationFrame(tick); } }
  function tick(t) {
    queued = false;
    var dt = lastT ? clamp(t - lastT, 1, 50) : 16.7, more = false, i;
    lastT = t;
    for (i = 0; i < tasks.length; i++) if (tasks[i].read) { try { tasks[i].read(t, dt); } catch (e) { warn(e); } }
    for (i = 0; i < tasks.length; i++) { try { if (tasks[i].write(t, dt)) more = true; } catch (e) { warn(e); } }
    dirty = false;
    if (more) kick(); else lastT = 0;
  }
  function onScroll() { dirty = true; kick(); }
  w.addEventListener('scroll', onScroll, { passive: true });
  w.addEventListener('resize', onScroll, { passive: true });
  w.addEventListener('load', onScroll);

  /* ------------------------------------------------------------------
     1. PARALLAX
     ------------------------------------------------------------------ */
  var pxList = [];
  var pxIO = io({ rootMargin: '30% 0px 30% 0px' }, function (es) {
    es.forEach(function (e) {
      (e.target.__pxItems || []).forEach(function (p) { p.vis = e.isIntersecting; p.el.classList.toggle('px-on', p.vis); });
    });
    onScroll();
  });
  function initPx(el) {
    if (el.__px || RM) return;
    var media = MEDIA.test(el.tagName), host = el.parentElement;
    if (host && host.tagName === 'PICTURE') host = host.parentElement;
    if (!host) return;
    el.__px = 1;
    var p = { el: el, box: media ? host : el, media: media, s: num(el.getAttribute('data-px'), 0.12), vis: true, y: 0, sc: 1, ny: null, ns: 1, set: false };
    if (media) host.classList.add('px-host');
    (p.box.__pxItems = p.box.__pxItems || []).push(p);
    pxList.push(p);
    if (pxIO) pxIO.observe(p.box);
  }
  tasks.push({
    read: function () {
      if (!dirty) return;
      var H = viewH();
      for (var i = 0; i < pxList.length; i++) {
        var p = pxList[i];
        if (!p.vis) continue;
        var r = p.box.getBoundingClientRect();
        var h = r.height, top = p.media ? r.top : r.top - p.y;
        if (!h) continue;
        var lim = (H + h) / 2;
        var dist = clamp(top + h / 2 - H / 2, -lim, lim);
        p.ny = -p.s * dist;
        /* An empty edge could only show while that edge of the frame is on screen, and
           the frame edge is on screen only while |dist| <= (H - h) / 2. So the media has
           to overhang each edge by |s| * max(0, H - h) / 2, plus 2px of safety. */
        p.ns = p.media ? 1 + (2 * (Math.abs(p.s) * Math.max(0, H - h) / 2 + 2)) / h : 1;
      }
    },
    write: function () {
      for (var i = 0; i < pxList.length; i++) {
        var p = pxList[i];
        if (p.ny === null) continue;
        if (!p.set || Math.abs(p.ny - p.y) > 0.05 || Math.abs(p.ns - p.sc) > 0.0005) {
          p.y = p.ny; p.sc = p.ns; p.set = true;
          p.el.style.transform = 'translate3d(0,' + p.y.toFixed(2) + 'px,0)' +
            (p.media ? ' scale(' + p.sc.toFixed(4) + ') scale(var(--px-zoom,1))' : '');
        }
        p.ny = null;
      }
      return false;
    }
  });

  /* ------------------------------------------------------------------
     2. TILT
     ------------------------------------------------------------------ */
  var tiltActive = [];
  function baseTransform(el) {
    if (el.hasAttribute('data-bloom') || el.hasAttribute('data-rise')) return '';
    var s = w.getComputedStyle(el).transform;
    return s && s !== 'none' ? ' ' + s : '';
  }
  function initTilt(el) {
    if (el.__tilt || RM || !FINE) return;
    el.__tilt = 1;
    var t = { el: el, max: clamp(num(el.getAttribute('data-tilt'), 6) || 6, 1, 20), tx: 0, ty: 0, tg: 0, x: 0, y: 0, g: 0, rect: null, stale: true, base: '', on: false, active: false, persp: 1000 };
    function wake() {
      if (!t.active) { t.active = true; el.classList.add('is-tilting'); tiltActive.push(t); }
      kick();
    }
    function measure() {
      t.rect = el.getBoundingClientRect(); t.stale = false;
      t.persp = Math.max(800, Math.round(Math.max(t.rect.width, t.rect.height) * 2.2));
    }
    el.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'touch') return;
      if (!t.active) t.base = baseTransform(el);
      measure(); t.on = true; t.tg = 1; wake();
    }, { passive: true });
    el.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'touch' || !t.on) return;
      if (t.stale || !t.rect) measure();
      var r = t.rect;
      t.tx = clamp((e.clientX - r.left) / (r.width || 1), 0, 1) * 2 - 1;
      t.ty = clamp((e.clientY - r.top) / (r.height || 1), 0, 1) * 2 - 1;
      wake();
    }, { passive: true });
    el.addEventListener('pointerleave', function () { t.on = false; t.tx = 0; t.ty = 0; t.tg = 0; wake(); }, { passive: true });
  }
  w.addEventListener('scroll', function () { for (var i = 0; i < tiltActive.length; i++) tiltActive[i].stale = true; }, { passive: true });
  tasks.push({
    write: function (t0, dt) {
      var k = ease(dt, 0.011), more = false;
      for (var i = tiltActive.length - 1; i >= 0; i--) {
        var t = tiltActive[i], el = t.el;
        t.x += (t.tx - t.x) * k; t.y += (t.ty - t.y) * k; t.g += (t.tg - t.g) * k;
        var rest = !t.on && Math.abs(t.x) < 0.002 && Math.abs(t.y) < 0.002 && t.g < 0.004;
        if (rest) {
          el.style.transform = ''; el.classList.remove('is-tilting');
          el.style.removeProperty('--tilt-x'); el.style.removeProperty('--tilt-y'); el.style.removeProperty('--tilt-g');
          t.active = false; t.x = t.y = t.g = 0; tiltActive.splice(i, 1);
          continue;
        }
        el.style.transform = 'perspective(' + t.persp + 'px) rotateX(' + (-t.y * t.max).toFixed(3) + 'deg) rotateY(' +
          (t.x * t.max).toFixed(3) + 'deg) scale(' + (1 + 0.014 * t.g).toFixed(4) + ')' + t.base;
        el.style.setProperty('--tilt-x', t.x.toFixed(3));
        el.style.setProperty('--tilt-y', t.y.toFixed(3));
        el.style.setProperty('--tilt-g', t.g.toFixed(3));
        more = true;
      }
      return more;
    }
  });

  /* ------------------------------------------------------------------
     3. BLOOM
     ------------------------------------------------------------------ */
  var bloomIO = RM ? null : io({ rootMargin: '0px 0px -8% 0px', threshold: 0 }, function (es) {
    var arriving = es.filter(function (e) { return e.isIntersecting; }).map(function (e) { return e.target; });
    arriving.sort(function (a, b) { return a.compareDocumentPosition(b) & 4 ? -1 : 1; });
    var perParent = [];
    arriving.forEach(function (el) {
      bloomIO.unobserve(el);
      var slot = null;
      for (var i = 0; i < perParent.length; i++) if (perParent[i].p === el.parentNode) { slot = perParent[i]; break; }
      if (!slot) { slot = { p: el.parentNode, n: 0 }; perParent.push(slot); }
      var delay = Math.min(slot.n, 8) * 90 + Math.max(0, num(el.getAttribute('data-bloom-delay'), 0));
      slot.n++;
      if (delay) el.style.transitionDelay = delay + 'ms';
      el.classList.add('is-bloomed');
      setTimeout(function () { el.style.transitionDelay = ''; el.classList.add('bloom-done'); }, delay + 1400);
    });
  });
  if (bloomIO) html.classList.add('mo-bloom');
  function initBloom(el) {
    if (el.__bloom) return;
    el.__bloom = 1;
    if (bloomIO) bloomIO.observe(el); else el.classList.add('is-bloomed', 'bloom-done');
  }

  /* ------------------------------------------------------------------
     4. FLIP
     ------------------------------------------------------------------ */
  var peekIO = RM ? null : io({ threshold: 0.6 }, function (es) {
    var n = 0;
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      peekIO.unobserve(el);
      if (el.__flipTouched) return;
      setTimeout(function () {
        if (el.__flipTouched || el.getAttribute('aria-pressed') === 'true') return;
        el.classList.add('mo-peek');
      }, 700 + (n++) * 160);
    });
  });
  function initFlip(el) {
    if (el.__flip) return;
    el.__flip = 1;
    var isBtn = el.tagName === 'BUTTON';
    if (isBtn && !el.getAttribute('type')) el.setAttribute('type', 'button');
    if (!isBtn) {
      if (!el.hasAttribute('role')) el.setAttribute('role', 'button');
      if (!el.hasAttribute('tabindex')) el.tabIndex = 0;
    }
    if (el.getAttribute('aria-pressed') !== 'true') el.setAttribute('aria-pressed', 'false');
    el.classList.toggle('is-flipped', el.getAttribute('aria-pressed') === 'true');
    var turn = 0;
    function toggle() {
      var on = el.getAttribute('aria-pressed') !== 'true';
      el.__flipTouched = true;
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
      el.classList.toggle('is-flipped', on);
      el.classList.remove('mo-peek');
      if (!RM) { turn = 1 - turn; el.classList.remove('is-turn-a', 'is-turn-b'); el.classList.add(turn ? 'is-turn-a' : 'is-turn-b'); }
    }
    el.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a,button,input,select,textarea,label') : null;
      if (a && a !== el && el.contains(a)) return;
      toggle();
    });
    if (!isBtn) el.addEventListener('keydown', function (e) {
      if (e.target !== el) return;
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); toggle(); }
    });
    var inner = el.querySelector('.flip__in');
    if (inner) inner.addEventListener('animationend', function () { el.classList.remove('mo-peek'); });
    if (peekIO && inner && el.getAttribute('data-flip') !== 'still') peekIO.observe(el);
  }

  /* ------------------------------------------------------------------
     5. TURNTABLE  (ported from the V2 seed: 36 real frames on a canvas,
        scroll scrub, pause, enlarge, drag to spin; now with inertia, idle,
        retina sizing, a shared frame cache and a sticky-host option)
     ------------------------------------------------------------------ */
  var ttList = [], MASK = null;
  function Frames(tpl, n, pad) { this.tpl = tpl; this.n = n; this.pad = pad; this.imgs = []; this.ok = []; this.started = false; this.ratio = 0; this.views = []; }
  Frames.prototype.url = function (i) { var s = String(i); while (s.length < this.pad) s = '0' + s; return this.tpl.replace(/\{i\}/g, s); };
  Frames.prototype.load = function () {
    if (this.started) return;
    this.started = true;
    var self = this, n = this.n, order = [], seen = {};
    function add(k) { k = ((Math.round(k) % n) + n) % n; if (!seen[k]) { seen[k] = 1; order.push(k); } }
    add(0); [4, 8, 16].forEach(function (s) { for (var j = 0; j < s; j++) add(j * n / s); });
    for (var i = 0; i < n; i++) add(i);
    order.forEach(function (k) {
      var im = new Image();
      im.decoding = 'async';
      im.onload = function () {
        function done() {
          self.ok[k] = true;
          if (!self.ratio && im.naturalWidth) self.ratio = im.naturalWidth / im.naturalHeight;
          self.views.forEach(function (v) { v.key = ''; });
          kick();
        }
        if (im.decode) im.decode().then(done, done); else done();
      };
      im.src = self.url(k);
      self.imgs[k] = im;
    });
  };
  Frames.prototype.near = function (i) {
    var n = this.n;
    if (this.ok[i]) return i;
    for (var r = 1; r < n; r++) {
      if (this.ok[(i - r + n) % n]) return (i - r + n) % n;
      if (this.ok[(i + r) % n]) return (i + r) % n;
    }
    return -1;
  };
  function featherMask() {
    if (MASK) return MASK;
    var c = d.createElement('canvas'); c.width = 100; c.height = 132;
    var x = c.getContext('2d');
    var g = x.createLinearGradient(0, 0, 100, 0);
    g.addColorStop(0, 'rgba(0,0,0,0)'); g.addColorStop(0.07, 'rgba(0,0,0,1)'); g.addColorStop(0.93, 'rgba(0,0,0,1)'); g.addColorStop(1, 'rgba(0,0,0,0)');
    x.fillStyle = g; x.fillRect(0, 0, 100, 132);
    x.globalCompositeOperation = 'destination-in';
    var g2 = x.createLinearGradient(0, 0, 0, 132);
    g2.addColorStop(0, 'rgba(0,0,0,0)'); g2.addColorStop(0.03, 'rgba(0,0,0,1)'); g2.addColorStop(0.97, 'rgba(0,0,0,1)'); g2.addColorStop(1, 'rgba(0,0,0,0)');
    x.fillStyle = g2; x.fillRect(0, 0, 100, 132);
    MASK = c;
    return c;
  }

  /* one canvas that shows the frames: the inline pouch, or the lightbox */
  function View(frames, cv) {
    var v = this;
    this.f = frames; this.cv = cv; this.ctx = cv.getContext('2d');
    this.key = ''; this.off = 0; this.vel = 0; this.drag = null; this.suppress = false; this.lastIn = -1e9;
    this.cssW = 0; this.pos = 0; this.feather = true;
    frames.views.push(this);
    if (HAS_RO) new ResizeObserver(function (en) { var r = en[en.length - 1].contentRect; v.resize(r.width, r.height); }).observe(cv);
    else { v.resize(cv.clientWidth, cv.clientHeight); w.addEventListener('resize', function () { v.resize(cv.clientWidth, cv.clientHeight); }, { passive: true }); }
    bindDrag(this);
  }
  View.prototype.resize = function (cw, ch) {
    var cv = this.cv;
    var dpr = Math.min(w.devicePixelRatio || 1, 3);
    var bw = Math.max(1, Math.round(cw * dpr)), bh = Math.max(1, Math.round(ch * dpr));
    this.cssW = cw;
    if (cv.width !== bw || cv.height !== bh) { cv.width = bw; cv.height = bh; }
    this.key = '';
    this.paint(this.pos);
  };
  /* Scroll and drag show the nearest real frame, always crisp. Only the slow idle turn dissolves
     into the next frame, over the last 28% of each step, so the print is sharp most of the time
     and the idle never looks like stop-motion. */
  View.prototype.paint = function (pos, dissolve) {
    var f = this.f, n = f.n, ctx = this.ctx, cv = this.cv;
    if (!ctx || cv.width < 2 || cv.height < 2) return;
    pos = ((pos % n) + n) % n;
    if (!dissolve) pos = Math.round(pos) % n;
    var i0 = Math.floor(pos) % n, fr = pos - Math.floor(pos), i1 = (i0 + 1) % n;
    var a = f.near(i0);
    if (a < 0) return;
    var q = clamp((fr - 0.72) / 0.28, 0, 1); q = q * q * (3 - 2 * q);
    var b = (a === i0 && q > 0.02 && f.ok[i1]) ? i1 : -1;
    if (b < 0) q = 0; else q = Math.round(q * 40) / 40;
    var key = a + '|' + b + '|' + q + '|' + cv.width + 'x' + cv.height;
    if (key === this.key) return;
    this.key = key;
    var im = f.imgs[a], iw = im.naturalWidth || 1, ih = im.naturalHeight || 1;
    var W = cv.width, H = cv.height, s = Math.min(W / iw, H / ih);
    var dw = iw * s, dh = ih * s, dx = (W - dw) / 2, dy = (H - dh) / 2;
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.globalCompositeOperation = 'source-over'; ctx.globalAlpha = 1;
    ctx.clearRect(0, 0, W, H);
    ctx.imageSmoothingEnabled = true;
    if ('imageSmoothingQuality' in ctx) ctx.imageSmoothingQuality = s < 0.75 ? 'high' : 'medium';
    ctx.drawImage(im, dx, dy, dw, dh);
    if (b >= 0) { ctx.globalAlpha = q; ctx.drawImage(f.imgs[b], dx, dy, dw, dh); ctx.globalAlpha = 1; }
    if (this.el) {
      var k = this.cssW ? this.cssW / W : 1, fk = Math.round(dx * k) + ',' + Math.round(dy * k) + ',' + Math.round(dw * k);
      if (fk !== this.fk) {
        this.fk = fk;
        this.el.style.setProperty('--tt-fx', (dx * k).toFixed(1) + 'px'); this.el.style.setProperty('--tt-fy', (dy * k).toFixed(1) + 'px');
        this.el.style.setProperty('--tt-fw', (dw * k).toFixed(1) + 'px'); this.el.style.setProperty('--tt-fh', (dh * k).toFixed(1) + 'px');
      }
    }
    if (this.feather) {
      ctx.globalCompositeOperation = 'destination-in';
      ctx.drawImage(featherMask(), dx, dy, dw, dh);
      ctx.globalCompositeOperation = 'source-over';
    }
  };
  /* inertia after a flick, then settle on a whole frame so it never rests half blended */
  View.prototype.coast = function (dt, free) {
    if (this.drag) return true;
    if (this.vel) {
      this.off += this.vel * dt;
      this.vel *= Math.exp(-dt * 0.0032);
      if (Math.abs(this.vel) < 0.0006) this.vel = 0;
      return true;
    }
    if (!free) return false;
    var p = this.base() + this.off, tgt = Math.round(p) - this.base();
    if (Math.abs(tgt - this.off) < 0.003) { this.off = tgt; return false; }
    this.off += (tgt - this.off) * ease(dt, 0.02);
    return true;
  };
  View.prototype.base = function () { return 0; };

  function bindDrag(v) {
    var cv = v.cv;
    cv.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      v.drag = { id: e.pointerId, x0: e.clientX, off0: v.off, lx: e.clientX, lt: e.timeStamp || now(), moved: false, sp: 0 };
      v.vel = 0; v.lastIn = now();
      if (e.pointerType === 'mouse') e.preventDefault();
      try { cv.setPointerCapture(e.pointerId); } catch (x) { /* capture is a nicety */ }
      kick();
    });
    cv.addEventListener('pointermove', function (e) {
      var g = v.drag;
      if (!g || e.pointerId !== g.id) return;
      var dx = e.clientX - g.x0;
      if (!g.moved && Math.abs(dx) > 5) { g.moved = true; if (v.el) v.el.classList.add('is-dragging'); }
      var ppf = clamp((v.cssW || 400) / 26, 7, 22);
      v.off = g.off0 - dx / ppf;
      var t = e.timeStamp || now(), gap = Math.max(1, t - g.lt);
      g.sp = g.sp * 0.6 + (-(e.clientX - g.lx) / ppf / gap) * 0.4;
      g.lx = e.clientX; g.lt = t;
      v.lastIn = now();
      kick();
    }, { passive: true });
    function end(e, cancelled) {
      var g = v.drag;
      if (!g || (e && e.pointerId !== g.id)) return;
      v.drag = null;
      if (v.el) v.el.classList.remove('is-dragging');
      if (g.moved) {
        v.suppress = true;
        setTimeout(function () { v.suppress = false; }, 400);
        var t = e && e.timeStamp ? e.timeStamp : now();
        if (!cancelled && t - g.lt < 90) v.vel = clamp(g.sp, -0.05, 0.05);
      }
      v.lastIn = now();
      kick();
    }
    cv.addEventListener('pointerup', function (e) { end(e, false); });
    cv.addEventListener('pointercancel', function (e) { end(e, true); });
    cv.addEventListener('lostpointercapture', function (e) { end(e, true); });
  }

  /* the lightbox, built once on first use and shared by every turntable */
  var lb = null, lbView = null, lbOpen = false, lbReturn = null, lbX = null;
  function buildLB(frames) {
    lb = d.createElement('div');
    lb.className = 'tt-lb';
    lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', 'The pouch, enlarged');
    lb.hidden = true;
    lb.innerHTML = '<div class="tt-lb__in"><canvas class="tt-lb__cv" tabindex="0" role="img" aria-label="The Thunder Honey Daylight pouch. Drag, or use the arrow keys, to turn it."></canvas>' +
      '<p class="tt-lb__hint">' + (FINE ? 'Drag to turn the pouch. Press Escape to close.' : 'Drag sideways to turn the pouch.') + '</p></div>' +
      '<button type="button" class="tt-lb__x" aria-label="Close">&times;</button>';
    d.body.appendChild(lb);
    lbX = lb.querySelector('.tt-lb__x');
    var cv = lb.querySelector('canvas');
    lbView = new View(frames, cv);
    lbView.vis = false;
    lbX.addEventListener('click', closeLB);
    lb.addEventListener('click', function (e) { if ((e.target === lb || e.target.className === 'tt-lb__in') && !lbView.suppress) closeLB(); });
    lb.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); closeLB(); return; }
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); lbView.off += e.key === 'ArrowRight' ? 1 : -1; lbView.off = Math.round(lbView.off); lbView.key = ''; kick(); }
      if (e.key === 'Tab') { e.preventDefault(); (d.activeElement === lbX ? cv : lbX).focus(); }
    });
  }
  function openLB(src) {
    if (!lb) buildLB(src.f);
    if (lbView.f !== src.f) { lbView.f = src.f; src.f.views.push(lbView); }
    lbReturn = d.activeElement;
    lbView.off = lbView.pos = Math.round(src.pos || 0); lbView.vel = 0; lbView.key = '';
    lbView.cv.style.aspectRatio = String(src.f.ratio || 0.76);
    lbView.cv.classList.toggle('tt-lb__cv--alpha', !!src.f.alpha);
    lb.hidden = false; lbOpen = true; lbView.vis = true;
    html.classList.add('tt-lb-open');
    w.requestAnimationFrame(function () { w.requestAnimationFrame(function () { lb.classList.add('is-on'); }); });
    try { lbX.focus({ preventScroll: true }); } catch (e) { lbX.focus(); }
    kick();
  }
  function closeLB() {
    if (!lbOpen) return;
    lbOpen = false; lbView.vis = false; lbView.drag = null; lbView.vel = 0;
    lb.classList.remove('is-on');
    html.classList.remove('tt-lb-open');
    setTimeout(function () { if (!lbOpen) lb.hidden = true; }, 380);
    if (lbReturn && lbReturn.focus) { try { lbReturn.focus({ preventScroll: true }); } catch (e) { lbReturn.focus(); } }
    kick();
  }
  w.THMotionLightbox = { close: closeLB };

  var ttIO = io({ rootMargin: '400px 0px' }, function (es) {
    es.forEach(function (e) {
      var v = e.target.__ttView;
      if (!v) return;
      v.vis = e.isIntersecting;
      if (v.vis) v.f.load();
    });
    onScroll();
  });
  function roundBtn(cls, label) {
    var b = d.createElement('button');
    b.type = 'button'; b.className = 'tt__btn ' + cls;
    b.setAttribute('aria-label', label); b.title = label;
    return b;
  }
  function setPaused(v, on) {
    if (v.paused === on) return;
    v.paused = on;
    if (on) { v.idleV = 0; v.vel = 0; }
    else { v.off += v.sp - v.spT; v.sp = v.spT; }
    v.lastIn = now();
    v.el.classList.toggle('is-paused', on);
    (v.pauseBtns || []).forEach(function (b) {
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var l = on ? 'Play the turning pouch' : 'Pause the turning pouch';
      b.setAttribute('aria-label', l); b.title = l;
    });
    kick();
  }
  /* is the surface behind this element dark? (walks up to the first painted background) */
  function onDark(el) {
    for (var n = el; n && n.nodeType === 1; n = n.parentElement) {
      var c = w.getComputedStyle(n).backgroundColor.match(/[\d.]+/g);
      if (c && (c.length < 4 || +c[3] > 0.5)) return (0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2]) / 255 < 0.35;
    }
    return false;
  }
  function initTT(el) {
    if (el.__ttView) return;
    var tpl = el.getAttribute('data-src');
    if (!tpl) return;
    var n = clamp(parseInt(el.getAttribute('data-frames'), 10) || 36, 1, 720);
    var pad = parseInt(el.getAttribute('data-pad'), 10);
    if (!(pad >= 0 && pad < 9)) pad = 3;
    var cv = el.querySelector('canvas');
    if (!cv) {
      cv = d.createElement('canvas');
      cv.setAttribute('aria-label', 'The Thunder Honey Daylight pouch, turning');
      el.insertBefore(cv, el.firstChild);
    }
    if (!cv.getContext) return;
    if (!cv.hasAttribute('role')) cv.setAttribute('role', 'img');
    if (!cv.hasAttribute('tabindex')) cv.tabIndex = 0;
    /* The cut set (img/turntable-cut) has a clean alpha edge and is drawn as it is, on light and dark
       alike. The navy studio set (img/turntable) needs the lighten blend on a dark surface, and that
       blend lets a bright glow wash out the shadowed side of the pouch, so on a dark surface the navy
       set is swapped for the cut set that sits next to it. data-blend="lighten" keeps the old way. */
    var keepBlend = el.getAttribute('data-blend') === 'lighten', dark = onDark(el);
    if (dark && !keepBlend && /(^|\/)turntable\/f\{i\}/.test(tpl)) tpl = tpl.replace(/(^|\/)turntable\/f\{i\}/, '$1turntable-cut/f{i}');
    var alpha = /turntable-cut/.test(tpl) && !keepBlend;
    if (dark && !alpha) el.classList.add('tt--blend');
    var v = new View(new Frames(tpl, n, pad), cv);
    v.f.alpha = alpha;
    v.el = el; v.inline = true; v.vis = !ttIO;
    v.host = el.closest('[data-tt-host]');
    v.turns = Math.max(0, num(el.getAttribute('data-turns'), 1));
    v.idle = RM ? 0 : Math.max(0, num(el.getAttribute('data-idle'), 18));
    v.paused = false; v.sp = null; v.spT = 0; v.idleV = 0; v.deg = -1;
    /* on a dark surface the lighten blend already dissolves the frame edge, and the cut set has its own
       edge, so the feather pass is only for the navy set on a light surface */
    v.feather = el.getAttribute('data-feather') !== 'off' && !el.classList.contains('tt--blend') && !alpha;
    v.base = function () { return v.sp || 0; };
    v.degEls = all(v.host || el, '[data-tt-deg]');
    el.__ttView = v;
    ttList.push(v);

    var pbs = all(el, '[data-tt-pause]'), ebs = all(el, '[data-tt-enlarge]');
    if (!pbs.length && !ebs.length && el.getAttribute('data-controls') !== 'none') {
      var ctl = d.createElement('div');
      ctl.className = 'tt__ctl';
      if (v.idle > 0) { var pb = roundBtn('tt__btn--pause', 'Pause the turning pouch'); pb.setAttribute('data-tt-pause', ''); ctl.appendChild(pb); pbs = [pb]; }
      var eb = roundBtn('tt__btn--big', 'Enlarge the pouch'); eb.setAttribute('data-tt-enlarge', ''); ctl.appendChild(eb); ebs = [eb];
      el.appendChild(ctl);
    }
    v.pauseBtns = pbs;
    pbs.forEach(function (b) {
      b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', function (e) { e.stopPropagation(); setPaused(v, !v.paused); });
    });
    ebs.forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); openLB(v); }); });

    cv.addEventListener('click', function () { if (v.suppress) { v.suppress = false; return; } openLB(v); });
    cv.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault();
        v.off = Math.round(v.base() + v.off + (e.key === 'ArrowRight' ? 1 : -1)) - v.base();
        v.vel = 0; v.lastIn = now(); v.key = ''; kick();
      } else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLB(v); }
    });
    if (ttIO) ttIO.observe(el); else v.f.load();
    onScroll();
  }
  tasks.push({
    read: function (t) {
      if (!dirty || RM) return;
      var H = viewH();
      for (var i = 0; i < ttList.length; i++) {
        var v = ttList[i];
        if (!v.vis) continue;
        var r = (v.host || v.el).getBoundingClientRect(), p;
        var tot = r.height - H;
        if (v.host && tot > 0) p = clamp(-r.top / tot, 0, 1);
        else p = clamp((H - r.top) / (H + r.height), 0, 1);
        /* pass mode: the front faces you when the pouch is centred in the viewport */
        var tgt = (v.host && tot > 0 ? p : p - 0.5) * v.f.n * v.turns;
        if (Math.abs(tgt - v.spT) > 0.0005) { if (v.sp !== null) v.lastIn = t; v.spT = tgt; }
      }
    },
    write: function (t, dt) {
      var more = false;
      for (var i = 0; i < ttList.length; i++) {
        var v = ttList[i];
        if (!v.vis) continue;
        if (v.sp === null) v.sp = v.spT;
        var moving = false;
        if (!v.paused) {
          var gap = v.spT - v.sp;
          if (Math.abs(gap) > 0.002) { v.sp += gap * ease(dt, 0.011); moving = true; } else v.sp = v.spT;
        }
        var wantIdle = !v.paused && !v.drag && !v.vel && v.idle > 0 && t - v.lastIn > 1500 && !lbOpen;
        v.idleV += ((wantIdle ? v.f.n / (v.idle * 1000) : 0) - v.idleV) * ease(dt, 0.0022);
        if (!wantIdle && Math.abs(v.idleV) < 0.00002) v.idleV = 0;
        v.off += v.idleV * dt;
        var coasting = v.coast(dt, !moving && !v.idleV && !wantIdle);
        v.pos = v.sp + v.off;
        v.paint(v.pos, !moving && !v.drag && !v.vel && v.idleV > 0);
        var deg = Math.round((((v.pos % v.f.n) + v.f.n) % v.f.n) / v.f.n * 360) % 360;
        if (deg !== v.deg) {
          v.deg = deg;
          v.el.style.setProperty('--tt-p', (deg / 360).toFixed(3));
          for (var j = 0; j < v.degEls.length; j++) v.degEls[j].textContent = String(deg);
        }
        /* an idling pouch keeps the loop awake while it is on screen, so the idle can begin */
        if (moving || wantIdle || v.idleV || coasting || v.drag || (v.idle > 0 && !v.paused && !lbOpen)) more = true;
      }
      if (lbView && lbView.vis) {
        if (lbView.coast(dt, true) || lbView.drag) more = true;
        lbView.pos = lbView.off;
        lbView.paint(lbView.pos);
      }
      return more;
    }
  });

  /* ------------------------------------------------------------------
     6. MARQUEE  (Web Animations on the compositor; the loop only eases the
        playback rate for the hover stop)
     ------------------------------------------------------------------ */
  var mqList = [];
  var mqIO = io({ rootMargin: '120px 0px' }, function (es) {
    es.forEach(function (e) { var m = e.target.__mq; if (m) { m.vis = e.isIntersecting; m.sync(); } });
  });
  function ghost(node) {
    var c = node.cloneNode(true);
    c.setAttribute('aria-hidden', 'true');
    c.removeAttribute('id');
    all(c, '[id]').forEach(function (x) { x.removeAttribute('id'); });
    all(c, 'a,button,input,select,textarea,summary,video,iframe,[tabindex]').forEach(function (x) { x.setAttribute('tabindex', '-1'); });
    /* a copy of an image loads eagerly once the original has loaded (it is cached by then) */
    var src = all(node, 'img'), dst = all(c, 'img');
    dst.forEach(function (im, i) {
      var o = src[i];
      if (!o) return;
      if (o.complete && o.naturalWidth) im.loading = 'eager';
      else o.addEventListener('load', function () { im.loading = 'eager'; }, { once: true });
    });
    return c;
  }
  function initMarquee(el) {
    if (el.__mq) return;
    var kids = [].slice.call(el.children).filter(function (k) { return !/^(SCRIPT|TEMPLATE|STYLE)$/.test(k.tagName); });
    if (!kids.length) return;
    var m = el.__mq = { el: el, kids: kids, k: 1, W: 0, dur: 0, b: null, anim: null, rate: 1, vis: !mqIO, hover: false, focus: false,
      speed: Math.max(2, num(el.getAttribute('data-speed'), 40)), rev: String(el.getAttribute('data-dir') || '').toLowerCase() === 'rev' };
    el.classList.add('mq');
    var track = d.createElement('div'); track.className = 'mq__track';
    var a = d.createElement('div'); a.className = 'mq__set';
    kids.forEach(function (k) { a.appendChild(k); });
    track.appendChild(a); el.appendChild(track);
    m.track = track; m.a = a;
    m.sync = function () {
      if (!m.anim) return;
      var want = m.vis && m.rate > 0.004;
      if (want && m.anim.playState !== 'running') { m.anim.playbackRate = Math.max(m.rate, 0.01); m.anim.play(); }
      else if (!want && m.anim.playState === 'running') m.anim.pause();
    };
    if (RM || !track.animate) { el.classList.add('mq--manual'); return; }
    m.start = function () {
      var frac = 0;
      if (m.anim) {
        try { var ct = m.anim.currentTime || 0; frac = m.dur ? (ct % m.dur) / m.dur : 0; } catch (e) { frac = 0; }
        m.anim.cancel();
      }
      m.dur = m.speed * 1000 * m.k;
      m.anim = track.animate([{ transform: 'translate3d(0,0,0)' }, { transform: 'translate3d(' + (-m.W) + 'px,0,0)' }],
        { duration: m.dur, iterations: Infinity, easing: 'linear', direction: m.rev ? 'reverse' : 'normal' });
      m.anim.currentTime = frac * m.dur;
      if (m.rate < 1) m.anim.playbackRate = Math.max(m.rate, 0.01);
      if (!m.vis || m.rate <= 0.004) m.anim.pause();
    };
    m.layout = function () {
      m.queued = false;
      /* the space between items is the element's own CSS gap (read every time, so breakpoints work) */
      var g = w.getComputedStyle(el).columnGap;
      if (g && g !== 'normal' && parseFloat(g) > 0) { if (g !== m.gap) { m.gap = g; el.style.setProperty('--mq-gap-auto', g); } }
      else if (m.gap) { m.gap = ''; el.style.removeProperty('--mq-gap-auto'); }
      /* fractional widths: a rounded width would make the loop jump by a fraction of a pixel */
      var cw = el.clientWidth, sw = a.getBoundingClientRect().width;
      if (!cw || !sw) return;
      var unit = sw / m.k, k = clamp(Math.ceil(cw / unit), 1, 12);
      if (k !== m.k || !m.b) {
        while (a.children.length > kids.length) a.removeChild(a.lastChild);
        var i;
        for (i = 1; i < k; i++) kids.forEach(function (kid) { a.appendChild(ghost(kid)); });
        var b = d.createElement('div');
        b.className = 'mq__set';
        b.setAttribute('aria-hidden', 'true');
        b.inert = true;
        for (i = 0; i < k; i++) kids.forEach(function (kid) { b.appendChild(ghost(kid)); });
        if (m.b) track.replaceChild(b, m.b); else track.appendChild(b);
        m.b = b; m.k = k;
      }
      var W = a.getBoundingClientRect().width;
      if (Math.abs(W - m.W) > 0.01) { m.W = W; m.start(); }
    };
    function later() { if (!m.queued) { m.queued = true; w.requestAnimationFrame(m.layout); } }
    m.layout();
    if (HAS_RO) { var ro = new ResizeObserver(later); ro.observe(el); ro.observe(a); }
    else w.addEventListener('resize', later, { passive: true });
    function hold() { var h = m.hover || m.focus; if (h !== m.held) { m.held = h; kick(); } }
    el.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { m.hover = true; hold(); } }, { passive: true });
    el.addEventListener('pointerleave', function () { m.hover = false; hold(); }, { passive: true });
    el.addEventListener('focusin', function () { m.focus = true; hold(); });
    el.addEventListener('focusout', function () { m.focus = false; hold(); });
    mqList.push(m);
    if (mqIO) mqIO.observe(el);
  }
  tasks.push({
    write: function (t, dt) {
      var more = false;
      for (var i = 0; i < mqList.length; i++) {
        var m = mqList[i];
        if (!m.anim) continue;
        var tgt = m.held ? 0 : 1;
        if (m.rate === tgt) continue;
        m.rate += (tgt - m.rate) * ease(dt, 0.007);
        if (Math.abs(tgt - m.rate) < 0.01) m.rate = tgt;
        if (m.rate > 0.004) m.anim.playbackRate = m.rate;
        m.sync();
        if (m.rate !== tgt) more = true;
      }
      return more;
    }
  });

  /* ------------------------------------------------------------------
     7. COUNT
     ------------------------------------------------------------------ */
  var ctList = [];
  var ctIO = RM ? null : io({ threshold: 0.35 }, function (es) {
    es.forEach(function (e) { var c = e.target.__ct; if (e.isIntersecting && c) { c.go = true; ctIO.unobserve(e.target); } });
    kick();
  });
  function initCount(el) {
    if (el.__ct) return;
    var to = num(String(el.getAttribute('data-count') || '').replace(/[\s,   ]/g, ''), NaN);
    if (!isFinite(to)) return;
    var dec = clamp(parseInt(el.getAttribute('data-decimals'), 10) || 0, 0, 6);
    var lang = (((el.closest('[lang]') || html).getAttribute('lang')) || 'en').toLowerCase();
    var sv = lang.indexOf('sv') === 0;
    var sep = el.hasAttribute('data-sep') ? el.getAttribute('data-sep') : (sv ? ' ' : ',');
    var dp = sv ? ',' : '.';
    var c = el.__ct = { el: el, to: to, dec: dec, dur: Math.max(200, num(el.getAttribute('data-duration'), 1800)), t0: 0, go: false, done: false, last: '' };
    c.fmt = function (v) {
      var s = Math.abs(v).toFixed(dec).split('.');
      s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      return (v < 0 ? '-' : '') + s.join(dp);
    };
    if (!ctIO) return;
    ctList.push(c);
    el.textContent = c.last = c.fmt(0);
    ctIO.observe(el);
  }
  tasks.push({
    write: function (t) {
      var more = false;
      for (var i = 0; i < ctList.length; i++) {
        var c = ctList[i];
        if (!c.go || c.done) continue;
        if (!c.t0) {
          c.t0 = t;
          /* keep the neighbours still while the digits grow */
          if (w.getComputedStyle(c.el).display === 'inline') {
            c.el.style.display = 'inline-block';
            c.el.textContent = c.fmt(c.to);
            c.el.style.minWidth = c.el.getBoundingClientRect().width + 'px';
          }
        }
        var p = clamp((t - c.t0) / c.dur, 0, 1), e = 1 - Math.pow(1 - p, 4), v = c.to * e;
        var txt = c.fmt(c.dec ? v : Math.round(v));
        if (txt !== c.last) { c.el.textContent = txt; c.last = txt; }
        if (p >= 1) { c.done = true; c.el.classList.add('is-counted'); } else more = true;
      }
      return more;
    }
  });

  /* ------------------------------------------------------------------
     8. GRAIN  (CSS does the drawing; this only lets it flicker while on screen)
     ------------------------------------------------------------------ */
  var grIO = RM ? null : io({ rootMargin: '0px' }, function (es) {
    es.forEach(function (e) { e.target.classList.toggle('grain-on', e.isIntersecting); });
  });
  function initGrain(el) { if (el.__gr) return; el.__gr = 1; if (grIO) grIO.observe(el); }

  /* ------------------------------------------------------------------
     9. SCRUB  (added 29 Sep 2026: pinned scroll sequences; the contract is at the top)
     Reads the host's rect once per scrolled frame, eases the progress, and writes only
     custom properties and classes. Nothing here touches the other primitives.
     ------------------------------------------------------------------ */
  var scList = [];
  var scIO = RM ? null : io({ rootMargin: '60% 0px 60% 0px' }, function (es) {
    es.forEach(function (e) { var s = e.target.__sc; if (s) s.vis = e.isIntersecting; });
    onScroll();
  });
  function scSmooth(t) { return t * t * (3 - 2 * t); }
  function scTo(s, k, smoothly) {
    var r = s.el.getBoundingClientRect(), H = viewH(), tot = r.height - H;
    if (tot < H * 0.5) return; /* not pinned (the plain layout): every step is already on the page */
    var q = s.n > 1 ? clamp(k, 0, s.n - 1) / (s.n - 1) : 0;
    var y = Math.round((w.pageYOffset || html.scrollTop || 0) + r.top + (s.lead + q * (1 - 2 * s.lead)) * tot);
    try { w.scrollTo({ top: y, behavior: smoothly ? 'smooth' : 'auto' }); } catch (e) { w.scrollTo(0, y); }
  }
  function initScrub(el) {
    if (el.__sc || RM) return;
    var steps = all(el, '[data-scrub-step]').filter(function (x) { return x !== el; });
    if (!steps.length) return;
    var fors = el.id ? [].slice.call(d.querySelectorAll('[data-scrub-for="' + el.id + '"]')) : [];
    var gos = all(el, '[data-scrub-go]');
    fors.forEach(function (f) { gos = gos.concat(all(f, '[data-scrub-go]')); });
    var s = {
      el: el, steps: steps, n: steps.length, fors: fors, gos: gos, vis: !scIO, p: null, pt: 0, at: -1, pv: '', qv: '', memo: [],
      dwell: clamp(num(el.getAttribute('data-scrub-dwell'), 0.4), 0, 0.9),
      lead: clamp(num(el.getAttribute('data-scrub-lead'), 0.06), 0, 0.3)
    };
    el.__sc = s;
    steps.forEach(function (st, k) {
      st.style.setProperty('--k', String(k));
      st.addEventListener('focusin', function () { if (s.at !== k) scTo(s, k, true); });
    });
    gos.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        scTo(s, parseInt(b.getAttribute('data-scrub-go'), 10) || 0, true);
      });
    });
    el.classList.add('is-scrub');
    scList.push(s);
    if (scIO) scIO.observe(el);
    onScroll();
  }
  function scPaint(s) {
    var n = s.n, half = s.dwell / 2, span = Math.max(0.0001, 1 - 2 * half), i, k;
    var qn = clamp((s.p - s.lead) / Math.max(0.0001, 1 - 2 * s.lead), 0, 1), q = qn * (n - 1);
    var pv = s.p.toFixed(4), qv = qn.toFixed(4);
    if (pv !== s.pv || qv !== s.qv) {
      s.pv = pv; s.qv = qv;
      s.el.style.setProperty('--scrub', pv); s.el.style.setProperty('--scrub-q', qv);
      for (i = 0; i < s.fors.length; i++) { s.fors[i].style.setProperty('--scrub', pv); s.fors[i].style.setProperty('--scrub-q', qv); }
    }
    for (k = 0; k < n; k++) {
      var sk = q - k;
      var vin = sk >= -half ? 1 : scSmooth(clamp((sk + 1 - half) / span, 0, 1));
      var vout = sk <= half ? 0 : scSmooth(clamp((sk - half) / span, 0, 1));
      var key = clamp(sk, -2, 2).toFixed(3) + '|' + vin.toFixed(4) + '|' + vout.toFixed(4);
      if (key === s.memo[k]) continue;
      s.memo[k] = key;
      var st = s.steps[k];
      st.style.setProperty('--s', clamp(sk, -2, 2).toFixed(3));
      st.style.setProperty('--in', vin.toFixed(4));
      st.style.setProperty('--out', vout.toFixed(4));
      st.classList.toggle('is-live', vin > 0.0005 && vout < 0.9995);
    }
    var at = clamp(Math.round(q), 0, n - 1);
    if (at !== s.at) {
      s.at = at;
      for (k = 0; k < n; k++) s.steps[k].classList.toggle('is-on', k === at);
      s.gos.forEach(function (b) {
        var on = (parseInt(b.getAttribute('data-scrub-go'), 10) || 0) === at;
        b.classList.toggle('is-on', on);
        if (on) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
      });
      s.el.setAttribute('data-scrub-at', String(at));
      for (i = 0; i < s.fors.length; i++) s.fors[i].setAttribute('data-scrub-at', String(at));
    }
  }
  tasks.push({
    read: function () {
      if (!dirty) return;
      var H = viewH();
      for (var i = 0; i < scList.length; i++) {
        var s = scList[i];
        if (!s.vis) continue;
        var r = s.el.getBoundingClientRect(), tot = r.height - H;
        s.pt = tot > 0 ? clamp(-r.top / tot, 0, 1) : 0;
      }
    },
    write: function (t, dt) {
      var more = false;
      for (var i = 0; i < scList.length; i++) {
        var s = scList[i];
        if (!s.vis) continue;
        if (s.p === null) s.p = s.pt;
        var gap = s.pt - s.p;
        /* the same glide as the turntable, so the cards and the pouch move as one */
        if (Math.abs(gap) > 0.0002) { s.p += gap * ease(dt, 0.011); more = true; } else s.p = s.pt;
        scPaint(s);
      }
      return more;
    }
  });

  /* ------------------------------------------------------------------ */
  function refresh(root) {
    root = root && root.querySelectorAll ? root : d;
    var jobs = [
      ['[data-marquee]', initMarquee], ['[data-px]', initPx], ['[data-tilt]', initTilt], ['[data-bloom]', initBloom],
      ['[data-flip]', initFlip], ['[data-turntable]', initTT], ['[data-count]', initCount], ['.grain', initGrain],
      ['[data-scrub]', initScrub]
    ];
    jobs.forEach(function (j) { all(root, j[0]).forEach(function (el) { try { j[1](el); } catch (e) { warn(e); } }); });
    onScroll();
  }
  w.THMotion = { refresh: refresh, reducedMotion: RM };
  html.classList.add('mo');
  if (RM) html.classList.add('mo-rm');
  /* WebKit can run deferred scripts before the stylesheets have applied (it holds all styles while
     any sheet is pending). Everything here reads layout and colours, so wait for them (max 2.5 s). */
  function whenStyled(fn) {
    var t0 = now(), done = false;
    (function check() {
      if (done) return;
      /* motion.css sets --mo-ready on :root, so this is true once the page's CSS is really applied */
      if (w.getComputedStyle(html).getPropertyValue('--mo-ready').trim() || now() - t0 > 2500) { done = true; fn(); return; }
      setTimeout(check, 40);
    })();
  }
  function start() { whenStyled(function () { refresh(d); }); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})();
